import { render, staticRenderFns } from "./RegisteredFarmers.vue?vue&type=template&id=17892ac4&scoped=true"
import script from "./RegisteredFarmers.vue?vue&type=script&lang=js"
export * from "./RegisteredFarmers.vue?vue&type=script&lang=js"
import style0 from "./RegisteredFarmers.vue?vue&type=style&index=0&id=17892ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17892ac4",
  null
  
)

export default component.exports